export const MAIN_APP = process.env.PUBLIC_URL;
export const LOGIN_PAGE = MAIN_APP + "/login";
export const REMIND_PASS_PAGE = MAIN_APP + "/remindPass";
export const REGISTRATION_PAGE = MAIN_APP + "/registration";
export const REGISTRATION_SUCCESS_PAGE = MAIN_APP + "/registrationSuccess";
export const SALE_MOVIE_PAGE = MAIN_APP + "/saleMovie";
export const MOVIE_DETAILS_PAGE = MAIN_APP + "/movieDetails";
export const CINEMA_HALL_PAGE = MAIN_APP + "/cinemaHall";
export const FINALIZE_PAGE = MAIN_APP + "/finalize";
export const SALE_FOOD_PAGE = MAIN_APP + "/saleFood";
export const NEWS_PAGE = MAIN_APP + "/news";
export const LIMITED_TICKET_COLOR = MAIN_APP + "/ticketsColor";
export const LIMITED_TICKET_GROUP = MAIN_APP + "/ticketsGroup";
export const LIMITED_TICKET_SHAPE = MAIN_APP + "/ticketsShape";
export const VOUCHER = MAIN_APP + "/vouchers";
export const EVENT_SALE = MAIN_APP + "/events";
export const CALENDAR_SALE = MAIN_APP + "/calendarSale";
export const THREE_STEP = MAIN_APP + "/stepsSale";
export const PASSES_SALE = MAIN_APP + "/passes";
export const EXERCISE_SCHEDULE = MAIN_APP + "/schedule";
export const FRAME_SALE = MAIN_APP + "/frame";
export const UI_KIT = MAIN_APP + "/ui-kit";
export const GIFT_CARD_ACTIVE = MAIN_APP + "/giftCards";
export const ECARD_RECHARGE = MAIN_APP + "/cardRecharge";
export const BIRTHDAY_RESERVATION = MAIN_APP + "/birthdayReservation";
export const MODAL_TEST = MAIN_APP + "/modalWindow";
export const ACCOUNT_ACTIVATION = MAIN_APP + "/accountActivation";
export const HOURLY_SCHEDULE = MAIN_APP + "/hourlySchedule";
export const NEWSLETTER_FORM_WIDGET = MAIN_APP + "/newsletterFormWidget";
export const NEWSLETTER_CONFIRMATION = MAIN_APP + "/confirmNewsletter";
export const CHANGE_PASSWORD_CONFIRMATION = MAIN_APP + "/confirmChangePassword";
export const PURCHASE = MAIN_APP + "/purchaseSuccess";
export const PURCHASE_FAILED = MAIN_APP + "/purchaseFailed";      
export const WELCOME_MOBILE = MAIN_APP + "/welcomeMobile";
